import { Stack } from '@mui/material';

import AcadlyLogoSquareIcon from '../icons/AcadlyLogoSquare';

const StaticScreen = () => {
  return (
    <Stack height="100%" justifyContent="center" alignItems="center" component="section">
      <AcadlyLogoSquareIcon size={90} />
      <h1>Acadly for PowerPoint</h1>
    </Stack>
  );
};

export default StaticScreen;
